import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconPlay from 'components/icons/IconPlay';
import IconPlus from 'components/icons/iconPlus';
import useVideoMetadata from 'hooks/useVideoMetadata';
import useIsVideoPosterPlayable from 'hooks/useIsVideoPosterPlayable';
import { GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPGalleryRevampLifestyleThumb from './PDPGalleryRevampLifestyleThumb';

// Five top-aligned slots: video, lifestyle photos, "+" overflow
const TILE_SLOTS = 5;
const THUMB_CLASS = 'h-[42px] w-full';
// The imgix helper's 44x38 default renders blurry in these larger tiles
const THUMB_IMG_SIZE = {
  width: 56,
  height: 42
};
const PDPGalleryRevampLifestyleRail = t0 => {
  const $ = _c(20);
  const {
    introVideoId,
    onExpand,
    onSelectVideo,
    photos: t1,
    trackGalleryInteracted
  } = t0;
  const photos = t1 === undefined ? [] : t1;
  let t2;
  if ($[0] !== introVideoId) {
    t2 = {
      videoId: introVideoId
    };
    $[0] = introVideoId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    thumbnail: videoThumbnailUrl,
    videoUrl: videoPosterUrl
  } = useVideoMetadata(t2);
  const isPosterPlayable = useIsVideoPosterPlayable(videoPosterUrl);
  if (!photos.length) {
    return null;
  }
  const showVideoTile = !!introVideoId && (!!videoThumbnailUrl || isPosterPlayable);
  const reservedSlots = showVideoTile ? 1 : 0;
  const hasOverflow = photos.length > TILE_SLOTS - reservedSlots;
  const photoCount = Math.max(1, TILE_SLOTS - reservedSlots - (hasOverflow ? 1 : 0));
  const railPhotos = photos.slice(0, photoCount);
  const t3 = "flex flex-col gap-1.5 w-14";
  const t4 = "PDPGalleryRevampLifestyleRail";
  let t5;
  if ($[2] !== onSelectVideo || $[3] !== showVideoTile || $[4] !== trackGalleryInteracted || $[5] !== videoPosterUrl || $[6] !== videoThumbnailUrl) {
    t5 = showVideoTile && <PDPGalleryRevampLifestyleThumb ariaLabel="Play product video" className={THUMB_CLASS} imgSize={THUMB_IMG_SIZE} src={videoThumbnailUrl} videoUrl={videoPosterUrl} onClick={() => {
      onSelectVideo?.();
      trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
    }} icon={<IconPlay width={20} height={20} />} />;
    $[2] = onSelectVideo;
    $[3] = showVideoTile;
    $[4] = trackGalleryInteracted;
    $[5] = videoPosterUrl;
    $[6] = videoThumbnailUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onExpand || $[9] !== trackGalleryInteracted) {
    t6 = (t7, index) => {
      const {
        id,
        src
      } = t7;
      return <PDPGalleryRevampLifestyleThumb key={`PDPGalleryRevampRailThumb${id}`} dataXc="PDPGalleryRevampRailPhoto" className={THUMB_CLASS} imgSize={THUMB_IMG_SIZE} src={src} onClick={() => {
        onExpand(index);
        trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
      }} />;
    };
    $[8] = onExpand;
    $[9] = trackGalleryInteracted;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = railPhotos.map(t6);
  let t8;
  if ($[11] !== hasOverflow || $[12] !== onExpand || $[13] !== photos || $[14] !== trackGalleryInteracted) {
    t8 = hasOverflow && <PDPGalleryRevampLifestyleThumb ariaLabel={`Show all ${photos.length} photos`} dataXc="PDPGalleryRevampShowAllPhotos" className={THUMB_CLASS} borderClass="border-gray-light5" onClick={() => {
      onExpand(0);
      trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
    }}><IconPlus width={14} height={14} /></PDPGalleryRevampLifestyleThumb>;
    $[11] = hasOverflow;
    $[12] = onExpand;
    $[13] = photos;
    $[14] = trackGalleryInteracted;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className={t3} data-xc={t4}>{t5}{t7}{t8}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
PDPGalleryRevampLifestyleRail.propTypes = {
  introVideoId: PropTypes.string,
  onExpand: PropTypes.func,
  onSelectVideo: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  trackGalleryInteracted: PropTypes.func
};
export default PDPGalleryRevampLifestyleRail;